<template>
  <div>
  <header>
    <div class="app-header-branding">
      <a href="http://www.dmv.ri.gov/" title="Go to RI DMV Home Page" target="_blank" rel="noopener noreferrer">
        <img src="@ridmv/web-themes/images/logo.png" alt="RI DMV logo">
      </a>
      <div class="app-header-dmv">
        <div>State of Rhode Island</div>
        <div>Division of Motor Vehicles</div>
        <div>Department of Revenue</div>
      </div>
    </div>

    <div class="app-header-info">
      <div>
        <a href="http://www.dmv.ri.gov/contact/" target="_blank" rel="noopener noreferrer">Contact us</a>
        <a href="http://www.dmv.ri.gov/" target="_blank" rel="noopener noreferrer">RI DMV Home Page</a>
        <div class="signout-dropdown" v-if="$route.name == 'Profile' || $route.name =='RenewReg' || $route.name =='DuplicateReg' || $route.name =='CancelReg' || ($route.name =='UpdateContacts' && !$store.state.guestLogin.createContact) || $route.name == 'UpdateAddress'">
          <button class="dropdownbtn" @click="dropdownFunction">
            {{ initialsValue }}
          </button>
          <div class="dropdown-content" id="myDropdown" :class="$store.state.guestLogin.step <= 4 ? '' : 'left50'" >
           <button ref="button" @click="getLogout()">Logout</button> 
          </div>
          <div class="cart" v-if="$store.state.guestLogin.step <= 4">
            <span class="cart-count" v-if="$store.state.guestLogin.renewalCart">{{ $store.state.guestLogin.renewalCart.length == 0 ? '': $store.state.guestLogin.renewalCart.length }}</span>
            <input type="image" src="static/CartImageNew.png" class="cart-icon" :alt="`Cart contains ${$store.state.guestLogin.renewalCart.length} items`" @click="goToCart()" @keyup.enter="goToCart()"/>
          </div>
        </div>
      </div>
    </div>
  </header>
  <ModalExtendedLogin :showModalActive="activeModal" @getShowStatus="showGetModal" ref="extendedModal"/>
  <RenewRegConfirmationModal  :showRenewRegModalActive="renewRegActiveModal" @getRenewRegShowStatus="showRenewRegModal" ref="confirmationModal"/>
  <SessionInactiveModal :showSessionModalInactive="inactiveModal" @getShowInactiveStatus="showGetInactiveSessionModal" ref="sessionModal"/>
</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import * as COMMONS from '../store/_commons';
import ModalExtendedLogin from '../components/appModal/ModalExtendedLogin.vue';
import RenewRegConfirmationModal from '../components/appModal/RenewRegConfirmationModal.vue';
import SessionInactiveModal from './appModal/SessionInactiveModal.vue';

export default {
  data() {
    return {
      riPackage: '~@ridmv/web-themes',
      
      activeModal: false,
      activeTimer: null,
      renewRegActiveModal: false,
      inactiveModal: false,
    };
  },
  components: {
    ModalExtendedLogin,
    RenewRegConfirmationModal,
    SessionInactiveModal
  },
  computed: {
    ...mapGetters({
      personalInfo: COMMONS.GUEST_PERSONAL_INFO,
      statusInfo: COMMONS.GUEST_LOGIN_STATUS_INFO 
    }),
    initialsValue: function() {
      let result;
      if(this.personalInfo.personalInformation) {
        result = this.personalInfo.personalInformation.firstName.charAt(0) + '' + this.personalInfo.personalInformation.lastName.charAt(0);
      } 
      else {
        result = this.statusInfo.customerName.charAt(0);
      }
      return result;
    },
    showExtensionModalActive() {
      return this.$store.state.guestLogin.accessToken;
    },
    showInactiveSessionModal() {
      return this.$store.state.guestLogin.accessToken !=null && this.$store.state.guestLogin.accessToken !='';
    }
  },
  mounted() {
    window.onclick = function(event) {
      if(!event.target.matches('.dropdownbtn')) {
        let dropdowns = document.getElementsByClassName("dropdown-content");
        for (let i=0; i<dropdowns.length; i++) {
          let openDropdown = dropdowns[i];
          if(openDropdown.classList.contains('show')) {
            openDropdown.classList.remove('show');
          }
        }
      }
    }

    window.addEventListener('DOMContentLoaded', () => {
      // let inactiveTimer = this.inactiveTimer;
      let vm = this;
      function afterInterval() {
        // set the initial timer
        // let timer = setTimeout(callback, delay)

        const handler = () => {
          // cancel the previous timer
          // console.log('123 message');
          // set a new one going
          // timer = setTimeout(callback, delay)
          clearInterval(vm.inactiveTimer);
          clearTimeout();
          // clearInterval(vm.activeTimer);


          // vm.showExtensionModal();
          vm.showSessionInactiveModal();
          // clearInterval(inactiveTimer);
          // clearTimeout();
        }

        // mousemove or click will cancel timer and trigger a new one
        // window.addEventListener('mousemove', handler)
        window.addEventListener('click', handler)
        window.addEventListener('mousedown', handler)
        // window.addEventListener('touchstart', handler)
        window.addEventListener('keydown', handler)
        // clearInterval(inactiveTimer);
      }

      afterInterval(() => {
        console.log('SESSION TIMEOUT');
      })
    })
  },
  methods: {
    ...mapActions({
      getGuestLogout: COMMONS.GUEST_LOGIN_GET_LOGOUT,
      // getRemoveTransaction: COMMONS.GUEST_REMOVETRANSACTION,
      getCancelTransaction: COMMONS.GUEST_CANCELTRANSACTION
    }),
    getLogout() {
      this.getGuestLogout()
    },
    dropdownFunction () {
      document.getElementById("myDropdown").classList.toggle("show");
    },

    showGetModal(val) {
      clearTimeout();
      clearInterval(this.activeTimer);
      this.activeModal = val;
    },

    showGetInactiveSessionModal(val) {
      clearTimeout();
      clearInterval(this.inactiveTimer);
      this.inactiveModal = val;
    },

    checkModal() {
      if (this.activeModal) {
        this.getGuestLogout();
        this.clearInterval(this.activeTimer);
        this.clearTimeout();
      }
    },

    checkSessionInactiveModal() {
      if (this.inactiveModal) {
        this.getGuestLogout();
        this.clearInterval(this.inactiveTimer);
        this.clearTimeout();
      }
    },

    async showExtensionModal() {
      let duration = this.statusInfo.duration;
      let milliSeconds = (duration * 60000) - 60000;
      this.activeTimer = setInterval(() => {
        if(!this.inactiveModal) {
          this.activeModal = true;
          clearInterval(this.inactiveTimer);
          this.$refs.extendedModal.startTimer();
          setTimeout(() => {
            this.checkModal();
          }, 60000)
        }
      }, milliSeconds);
    },

    async showSessionInactiveModal() {
      if(this.showInactiveSessionModal && !this.activeModal) {
        // console.log('SHOW INACTIVE SESSION')
        this.inactiveDuration = 15;
        let milliSeconds = (this.inactiveDuration * 60000) - 60000;
        this.inactiveTimer = setInterval(() => {
          this.inactiveModal = true;
          // clearInterval(this.activeTimer);
          this.$refs.sessionModal.startTimer();
          setTimeout(() => {
            this.checkSessionInactiveModal();
          }, 60000)
        }, milliSeconds);
      }
    },

    goToCart() {
      if(this.$store.state.guestLogin.renewalCart && this.$store.state.guestLogin.renewalCart.length > 0 ) {
        if(this.$store.state.guestLogin.step > 1 && this.$store.state.guestLogin.step < 4) {
          this.renewRegActiveModal = true;
        }
        else {
          this.$store.state.guestLogin.step = 4;
          // this.$route.name !='RenewReg' ? this.$router.push({name: 'RenewReg'}) : null;
          if (this.$route.name !='RenewReg' && this.$route.name !='DuplicateReg' && this.$route.name !='CancelReg') {
              // this.$store.state.guestLogin.duplicateReg ? this.$router.push({name: 'DuplicateReg'}) : this.$store.state.guestLogin.cancelReg ? this.$router.push({name: 'CancelReg'})
              // : this.$router.push({name: 'RenewReg'})
              if(this.$store.state.guestLogin.duplicateReg) {
                  this.$router.push({name: 'DuplicateReg'});
              } else if(this.$store.state.guestLogin.cancelReg) {
                this.$router.push({name: 'CancelReg'});
              } else{
                this.$router.push({name: 'RenewReg'});
              }
          } 
        }  
      }
    },
    async showRenewRegModal(val) {
      this.renewRegActiveModal = false;
      if(val == 'Yes') {
          // await this.getRemoveTransaction().then( () => {
          await this.getCancelTransaction().then( () => {
            this.$store.state.guestLogin.step = 4;
          }) 
      }
    },
  },

  watch : {
    showExtensionModalActive(newVal, oldVal) {
      // console.log('thi sis test', this.$store.state.guestLogin)
      console.log(newVal)
      console.log(oldVal)
      if(newVal != '') {
        this.showExtensionModal();
        this.showSessionInactiveModal();
      }
    }
  },

  beforeDestroy() {
    clearInterval(this.activeTimer);
    clearInterval(this.inactiveTimer);
    clearTimeout();
  }
}
</script>

<style lang="scss" scoped>
@import "~@ridmv/web-themes/styles/header";

.app-header-info{
    .cart {
    height: 40px;
    position: relative;
    padding: 0.5rem;
    .cart-count {
      position: absolute;
      top: 0%;
      font-weight: bold;
      text-align: center;
      width: 47px;
      color: white;
      font-size: 14px;
    }
    
    .cart-icon{
      width: 46px;
      height: 46px;
      vertical-align: middle;
      top: 10%;
      position: absolute;
      cursor: pointer;

      &:focus {
        outline-color: orange;
      }
    }
  }
}
.signout-dropdown {
  position: relative;
  display: inline-flex;

  .dropdownbtn {
    background-color: var(--ri-light-blue);
    border-radius: 50%;
    font-size: 1rem;
    border: 3px solid white;
    padding: 0.5em 0.2em;
    height: 40px;
    width: 40px;
    color: #000;
    min-width: 40px;

    &:hover {
      background-color: orange;
      border: 3px solid orange;
    }
  }

  .left50 {
    left: 33% !important;
  }

  .show {
    display: block !important;
  }
  .dropdown-content {
    display: none;
    position: absolute;
    left: 27%;
    z-index: 1000;
    width: 185px;
    padding: 1rem;
    box-shadow: 7px 10px 8px 0px rgb(0 0 0 / 20%);
    background-color: white;
    transform: translate(-50%, 15%);
    margin-top: 3rem;
    ::after {
      content: '';
      width: 15px;
      height: 15px;
      position: absolute;
      transform: rotate(135deg);
      background-color: white;
      z-index: 999;
      top: -6px;
      right: 27%;
    }
    a {
      color: #000;
      font-size: 18px;
      margin: 5px;
    }
    button {
      min-width: 145px;
      border: 0px solid;
    }
    
    @media only screen and (max-width: 800px) {
      ::after {
        content: '';
        right: 44%;
      }
    }
  }
}
header {
  @media only screen and (max-width: 800px) {
    .app-header-info {
      a {
        white-space: normal;
      }
      .cart {
        .cart-count{
          position: absolute;
          top: 0%;
          font-weight: bold;
          text-align: center;
          width: 47px;
          color: #000;
          font-size: 14px;
        }
      }
    }
  }     
  @media only screen and (min-width: 801px) and (max-width:960px) {
    .app-header-info {
      a {
        white-space: normal;
        display: block;
        width: 100%;
      }
    }
  }   
}
</style>
